<template>
    <div class="account">
        <div class="action-header">
            <div class="action-header__title">
                Overview
            </div>
        </div>

        <div class="account__actions actions">
            <div class="actions__search-container">
                <input @input="getWhiteListData()" class="actions__search-input" v-model="filter.query" type="text" placeholder="Search by IP"/>
                <inline-svg
                    class="actions__search-icon"
                    src="/images/search.svg" aria-label="search">
                </inline-svg>
                <inline-svg
                    v-show="filter.query"
                    @click="clearSearch()"
                    class="clear-search"
                    src="/images/clear.svg" aria-label="clear">
                </inline-svg>
            </div>
        </div>

        <div class="white-list-add-account-wrapper">
            <div class="account__actions actions">
                <button type="button" class="actions__add-account" @click="show">Add IP</button>
            </div>
        </div>

        <div class="account__table main-table main-table-whitelist">
            <table class="main-table__wrapper">
                <thead class="main-table__header">
                <th class="main-table__header-item">IP</th>
                <th class="main-table__header-item" width="100px">Action</th>
                </thead>
                <tbody class="main-table__body">
                    <template v-if="isLoading" >
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="7">
                                <div class="loader">
                                    <svg class="circular" viewBox="25 25 50 50">
                                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                                    </svg>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else-if="tableData">
                        <tr v-for="item in tableData" class="main-table__row-container">
                            <td class="main-table__row-item not-pointer-column">{{ item.ip }}</td>
                            <td class="main-table__row-item not-pointer-column" align="center" valign="middle" style="padding: 0">
                                <inline-svg
                                    class="main-table__edit-icon"
                                    src="/images/trash.svg"
                                    style="height: 20px;opacity: 1!important;position: initial"
                                    @click="deleteIp(item.ip)"
                                />
                            </td>
                        </tr>
                    </template>
                    <template v-else="tableData.length">
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="7">Not found</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <modal :height="'auto'" :width="'400px'" name="ip-modal" @opened="focusInput()">
            <div class="informative-modal flex flex-col">
                <div class="header" style="padding-bottom: 30px;">
                    Add IP To Whitelist
                </div>
                <div class="body">
                    <form class="ip-form">
                        <label class="ip-form__label">
                            <span class="ip-form__field-title">
                                Enter IP
                            </span>
                            <div class="ip-form__field-container">
                                <input id="focusip" v-model="addData.address" class="ip-form__field" required/>
                            </div>
                        </label>
                        <div class="error" v-if="error_text">
                            {{ error_text }}
                        </div>
                    </form>
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn mr-2" @click="hide">Cancel</button>
                    <button class="btn btn-primary" @click="addIp">Apply</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import {whiteListTable, whiteListTableTitles} from "../../helpers/white-list-table";

    export default {
        name: 'white-list',
        data: function () {
            return {
                isLoading: false,
                tableTitles: whiteListTableTitles(),
                tableData: null,
                accounts: [],
                error_text: '',
                addData: {
                    account_id: null,
                    address: "",
                },
                filter: {
                    query: ''
                }
            }
        },
        methods: {
            focusInput () {
                document.getElementById('focusip').focus()
            },
            clearSearch() {
                this.filter.query = '';
                this.getWhiteListData();
            },
            getWhiteListData() {
                const last_search_value = this.filter.query;
                if(this.isLoading) return;
                this.isLoading = true;
                axios.get('whitelist/total',
                    {
                        params: {query: this.filter.query}
                    })
                    .then(info => {
                        this.isLoading = false;
                        if(last_search_value === this.filter.query){
                            const {data: {items = []}} = info;
                            this.tableData = whiteListTable(items);
                        }
                        else{
                            this.getWhiteListData();
                        }
                    })
                    .catch(err => {
                        this.isLoading = false;
                        console.log('err', err);
                    });
            },
            getUserAccounts() {
                axios.get('account/list')
                    .then(info => {
                        const {data: {items = []}} = info;
                        this.accounts = items;
                    })
                    .catch(err => console.log('err', err));
            },
            addIp() {
                axios.post('whitelist/add', this.addData)
                    .then(info => {
                        this.getWhiteListData();
                        this.error_text = '';
                        this.hide();
                    })
                    .catch(err => {
                        if (err.response.data && err.response.data.errors && Object.values(err.response.data.errors).length > 0) {
                            this.error_text = Object.values(err.response.data.errors)[0][0];
                        }
                    });
            },
            deleteIp(ip) {
                axios.post('whitelist/delete', {address: ip})
                    .then(info => {
                        this.getWhiteListData();
                    })
                    .catch(err => {
                        if (err.response.data && err.response.data.errors && Object.values(err.response.data.errors).length > 0) {
                            this.$notify({
                                group: 'foo',
                                type: 'warn',
                                title: 'Error',
                                text: Object.values(err.response.data.errors)[0][0]
                            });
                        }
                    });
            },
            show() {
                this.$modal.show('ip-modal');
            },
            hide() {
                this.$modal.hide('ip-modal');
            }
        },
        mounted() {
            this.getWhiteListData();
            this.getUserAccounts();
        }
    }
</script>
